function isFullWidth(code: number): boolean {
  return (
    (code >= 0x3000 && code <= 0x9fff) ||
    (code >= 0xf900 && code <= 0xfaff) ||
    (code >= 0xff01 && code <= 0xff60) ||
    (code >= 0xffe0 && code <= 0xffe6) ||
    (code >= 0x20000 && code <= 0x2fa1f)
  );
}

export function getHalfWidthLength(str: string): number {
  let len = 0;
  for (const char of str) {
    const code = char.codePointAt(0) ?? 0;
    len += isFullWidth(code) ? 2 : 1;
  }
  return len;
}

export function truncateToHalfWidth(str: string, maxHalfWidth: number): string {
  let len = 0;
  let i = 0;
  for (const char of str) {
    const code = char.codePointAt(0) ?? 0;
    const w = isFullWidth(code) ? 2 : 1;
    if (len + w > maxHalfWidth) break;
    len += w;
    i += char.length;
  }
  return str.slice(0, i);
}
